import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../actions/configApi'; // Assumindo que você tem um arquivo de API configurado

// Função para carregar o carrinho do localStorage
const loadCartFromLocalStorage = () => {
    try {
        const cart = localStorage.getItem('cart');
        return cart ? JSON.parse(cart) : [];
    } catch (error) {
        console.error("Erro ao carregar o carrinho do localStorage:", error);
        return [];
    }
};

// Função para salvar o carrinho no localStorage
const saveCartToLocalStorage = (cart) => {
    try {
        localStorage.setItem('cart', JSON.stringify(cart));
    } catch (error) {
        console.error("Erro ao salvar o carrinho no localStorage:", error);
    }
};

const calculateTotal = (products) => {
    console.log('🔍 Iniciando cálculo do total. Produtos recebidos:', products);

    return products.reduce((total, product, index) => {
        console.log(`\n🛒 Produto #${index + 1}:`, product);

        const rawPrice = product.price;
        const rawQuantity = product.quantity;

        console.log(`📦 rawPrice:`, rawPrice, `| typeof:`, typeof rawPrice);
        console.log(`📦 rawQuantity:`, rawQuantity, `| typeof:`, typeof rawQuantity);

        const price = parseFloat(rawPrice);
        const quantity = parseInt(rawQuantity);

        console.log(`✅ convertidos => price:`, price, `| quantity:`, quantity);

        if (isNaN(price) || isNaN(quantity)) {
            console.warn(`❌ Produto com valores inválidos (ignorando no total):`, product);
            return total;
        }

        const subtotal = price * quantity;
        console.log(`💰 Subtotal do produto #${index + 1}:`, subtotal);

        return total + subtotal;
    }, 0);
};

export const syncCartWithServer = createAsyncThunk(
    'cart/syncCartWithServer',
    async (_, { getState, rejectWithValue }) => {
        try {
            const { cart } = getState();
            const productIds = cart.products.map(p => p.id);

            // Envia para o servidor os IDs dos produtos no carrinho
            const response = await api.post('/products/validate-cart', { ids: productIds });

            const updatedProducts = response.data.updatedProducts.map(serverProduct => {
                const localProduct = cart.products.find(p => p.id === serverProduct.id);
                return {
                    ...serverProduct,
                    quantity: localProduct?.quantity || 1,
                };
            });

            return updatedProducts;
        } catch (error) {
            console.error('Erro ao sincronizar carrinho com servidor:', error);
            return rejectWithValue('Falha ao sincronizar carrinho com servidor');
        }
    }
);

const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        products: JSON.parse(localStorage.getItem('cart')) || [],
        totalAmount: parseFloat(localStorage.getItem('totalAmount')) || 0,
        deliveryMethod: '', // 'retirada' ou 'entrega'
    },
    reducers: {
        addProductToCart: (state, action) => {
            const product = action.payload;
            const existingProduct = state.products.find((item) => item.id === product.id);

            if (!existingProduct) {
                state.products.push({ ...product, quantity: product.quantity || 1 });
            }
            state.totalAmount = calculateTotal(state.products);
            localStorage.setItem('cart', JSON.stringify(state.products));
            localStorage.setItem('totalAmount', state.totalAmount);
        },
        removeProductFromCart: (state, action) => {
            state.products = state.products.filter((product) => product.id !== action.payload);
            state.totalAmount = calculateTotal(state.products);
            localStorage.setItem('cart', JSON.stringify(state.products));
            localStorage.setItem('totalAmount', state.totalAmount);
        },
        clearCart: (state) => {
            state.products = [];
            saveCartToLocalStorage(state.products); // Salva no localStorage
        },
        updateProductQuantity: (state, action) => {
            const { productId, quantity } = action.payload;
            const product = state.products.find((item) => item.id === productId);

            if (product && quantity > 0) {
                product.quantity = quantity;
            } else {
                state.products = state.products.filter((item) => item.id !== productId);
            }
            state.totalAmount = calculateTotal(state.products);
            localStorage.setItem('cart', JSON.stringify(state.products));
            localStorage.setItem('totalAmount', state.totalAmount);
        },
        setDeliveryMethod: (state, action) => {
            state.deliveryMethod = action.payload;
            localStorage.setItem('deliveryMethod', state.deliveryMethod);
        },
        finalizePurchase: (state) => {
            // Armazena as informações de finalização
            const purchaseSummary = {
                products: state.products,
                totalAmount: state.totalAmount,
                deliveryMethod: state.deliveryMethod,
            };
            localStorage.setItem('purchaseSummary', JSON.stringify(purchaseSummary));
        },
    },
    extraReducers: (builder) => {
        builder.addCase(syncCartWithServer.fulfilled, (state, action) => {
            // Atualiza os produtos com os dados recebidos do servidor
            state.products = action.payload;
            state.totalAmount = calculateTotal(state.products);
            localStorage.setItem('cart', JSON.stringify(state.products));
            localStorage.setItem('totalAmount', state.totalAmount);
        });
    }
});

export const {
    addProductToCart,
    removeProductFromCart,
    updateProductQuantity,
    setDeliveryMethod,
    finalizePurchase,
    clearCart,
} = cartSlice.actions;

export default cartSlice.reducer;
